import UserBookByStatusCard from "components/Bookcards/UserBookByStatusCard/UserBookByStatusCard";
import { LetterbookLibraryType } from "features/Letterbooks/types";

export default function LetterbookUserBookByStatusCard({
  letterbook,
}: {
  letterbook: LetterbookLibraryType;
}) {
  return (
    <UserBookByStatusCard
      book={letterbook.book}
      userBook={letterbook.data.ownerUserBook}
      className="p-4"
    />
  );
}
